import Enum from "../../../enums/Enum";

const MedicalTourismPayerTypeEnum = new Enum({
    SELF_PAY: {name: "Medical Tourism Self Pay"},
    OTHER: {name: "Medical Tourism Other"},
});

export default MedicalTourismPayerTypeEnum;
